import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Modal } from "@/components/modals/Modal";

export function RemoveSlotModal({ open, onClose, onConfirm, count, setCount, max, removing }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Remove Plan Slot"
      subtitle="This action cannot be undone."
      icon={<AlertTriangle size={16} className="text-destructive" />}
      maxWidth="max-w-sm"
    >
      <div className="px-6 py-5 space-y-4">
        {/* Primary warning */}
        <div className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-3 space-y-1">
          <p className="text-sm font-semibold text-foreground">
            You will lose access to this plan slot
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Removing a slot permanently removes a paid plan position for the rest of the current
            billing year. Any unused plan credits in that slot are forfeited - no refund is issued.
          </p>
        </div>

        {/* Redirect hint */}
        <div className="rounded-lg border border-border bg-muted/30 px-4 py-3">
          <p className="text-sm text-muted-foreground leading-relaxed">
            <span className="font-medium text-foreground">Trying to move a teacher out of a slot?</span>{" "}
            Don&apos;t remove the slot - use the{" "}
            <span className="font-medium text-foreground">Remove</span> button on the teacher card
            to unassign them. The slot stays active and can be reassigned to another teacher.
          </p>
        </div>

        {/* Count input */}
        <div className="space-y-1.5">
          <Label className="text-sm font-medium">
            How many empty slots to remove?
          </Label>
          <Input
            type="number"
            min={1}
            max={max}
            value={count}
            onChange={e => setCount(e.target.value)}
            className="h-9 w-28"
          />
          <p className="text-xs text-muted-foreground">
            {max} unassigned slot{max !== 1 ? "s" : ""} available to remove. Only empty slots can be removed.
          </p>
        </div>

        <div className="flex gap-2 pt-1">
          <Button
            variant="destructive"
            disabled={removing || !count || Number(count) < 1 || Number(count) > max}
            onClick={onConfirm}
          >
            {removing ? "Removing…" : "Remove Slot"}
          </Button>
          <Button variant="outline" onClick={onClose} disabled={removing}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
